<p-dialog [header]="ui('Advanced Search', 'بحث متقدم')" [visible]="advancedSearchVisible()"
  (visibleChange)="advancedSearchVisible.set($event)" [modal]="true" [style]="{ width: 'min(96vw, 1320px)' }"
  [contentStyle]="{ overflow: 'visible' }" [draggable]="false">
  <form [formGroup]="filtersForm" class="advanced-search-form">
    <div class="advanced-search-grid">
      <div class="filter-field wide-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.search"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <input pInputText id="availabilitySearchText" formControlName="searchText" />
            <label for="availabilitySearchText">{{ ui('Search reference, route, equipment, contact or status', 'ابحث بالمرجع أو المسار أو المعدة أو جهة الاتصال أو الحالة') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.list"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <input pInputText id="availabilityReferenceNumber" formControlName="referenceNumber" />
            <label for="availabilityReferenceNumber">{{ ui('Reference Number', 'الرقم المرجعي') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.user"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select [options]="contactOptions()" formControlName="contactName" appendTo="body" inputId="contactName"
              class="w-full" [filter]="true" [showClear]="true"></p-select>
            <label for="contactName">{{ ui('Contact', 'جهة الاتصال') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.marker"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select [options]="originOptions()" formControlName="origin" appendTo="body" inputId="advancedOrigin"
              class="w-full" [filter]="true" [showClear]="true"
              (onFilter)="onLocationOptionFilter('origin', $event)"></p-select>
            <label for="advancedOrigin">{{ ui('Origin', 'مصدر الاستلام') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.mapLocation"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select [options]="destinationOptions()" formControlName="destination" appendTo="body"
              inputId="advancedDestination" class="w-full" [filter]="true" [showClear]="true"
              (onFilter)="onLocationOptionFilter('destination', $event)"></p-select>
            <label for="advancedDestination">{{ ui('Destination', 'وجهة التسليم') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.truck"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select [options]="equipmentOptions()" formControlName="equipment" appendTo="body"
              inputId="advancedEquipment" class="w-full" [filter]="true" [showClear]="true"
              (onFilter)="onLocationOptionFilter('equipment', $event)"></p-select>
            <label for="advancedEquipment">{{ ui('Equipment', 'المعدة') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-datepicker id="availableDate" formControlName="date" appendTo="body" styleClass="w-full"
              [showIcon]="false"></p-datepicker>
            <label for="availableDate">{{ ui('Available On', 'متاح في') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-datepicker id="availableFrom" formControlName="availableFrom" appendTo="body" styleClass="w-full"
              [showIcon]="false"></p-datepicker>
            <label for="availableFrom">{{ ui('Available From', 'متاح من') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-datepicker id="availableTo" formControlName="availableTo" appendTo="body" styleClass="w-full"
              [showIcon]="false"></p-datepicker>
            <label for="availableTo">{{ ui('Available To', 'متاح إلى') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-datepicker id="createdAtFrom" formControlName="createdAtFrom" appendTo="body" styleClass="w-full"
              [showIcon]="false"></p-datepicker>
            <label for="createdAtFrom">{{ ui('Created At From', 'أنشئ من') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-datepicker id="createdAtTo" formControlName="createdAtTo" appendTo="body" styleClass="w-full"
              [showIcon]="false"></p-datepicker>
            <label for="createdAtTo">{{ ui('Created At To', 'أنشئ إلى') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.table"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-inputNumber inputId="advancedMinPallets" formControlName="minPallets" [min]="0"
              [showButtons]="false"></p-inputNumber>
            <label for="advancedMinPallets">{{ ui('Min Pallets', 'أقل عدد منصات') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.weight"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-inputNumber inputId="advancedMaxWeight" formControlName="maxWeight" [min]="0"
              [showButtons]="false"></p-inputNumber>
            <label for="advancedMaxWeight">{{ ui('Min Weight Capacity', 'أقل سعة وزن') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.box"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <input pInputText id="minRoutePrice" type="number" formControlName="minRoutePrice" />
            <label for="minRoutePrice">{{ ui('Route Price Min', 'أقل سعر للمسار') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.box"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <input pInputText id="maxRoutePrice" type="number" formControlName="maxRoutePrice" />
            <label for="maxRoutePrice">{{ ui('Route Price Max', 'أعلى سعر للمسار') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.box"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select [options]="currencyOptions()" formControlName="currency" appendTo="body" inputId="currency"
              class="w-full" [filter]="true" [showClear]="true"></p-select>
            <label for="currency">{{ ui('Currency', 'العملة') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.userTie"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select [options]="visibilityOptions()" formControlName="visibility" appendTo="body" inputId="visibility"
              class="w-full" [filter]="true" [showClear]="true"></p-select>
            <label for="visibility">{{ ui('Visibility', 'الظهور') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><fa-icon [icon]="icons.warning"></fa-icon></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select [options]="statusOptions()" formControlName="status" appendTo="body" inputId="status"
              class="w-full" [filter]="true" [showClear]="true"></p-select>
            <label for="status">{{ ui('Status', 'الحالة') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="preference-card advanced-preferences">
        <span class="selection-label">{{ ui('Preferences', 'التفضيلات') }}</span>
        <label class="checkbox-row">
          <p-checkbox formControlName="hazmatCertified" [binary]="true" inputId="advancedHazmat"></p-checkbox>
          <span>{{ ui('Hazmat Certified', 'معتمد للمواد الخطرة') }}</span>
        </label>
        <label class="checkbox-row">
          <p-checkbox formControlName="teamDrivers" [binary]="true" inputId="advancedTeam"></p-checkbox>
          <span>{{ ui('Team Drivers', 'سائقان') }}</span>
        </label>
        <label class="checkbox-row">
          <p-checkbox formControlName="openToNegotiation" [binary]="true" inputId="openToNegotiation"></p-checkbox>
          <span>{{ ui('Open to Negotiation', 'قابل للتفاوض') }}</span>
        </label>
        <label class="checkbox-row">
          <p-checkbox formControlName="instantMatchEnabled" [binary]="true" inputId="instantMatchEnabled"></p-checkbox>
          <span>{{ ui('Instant Match', 'مطابقة فورية') }}</span>
        </label>
      </div>
    </div>

    <div class="advanced-actions">
      <button pButton type="button" [label]="ui('Refresh Options', 'تحديث الخيارات')" class="p-button-text p-button-secondary icon-button"
        [loading]="filterOptionsLoading()" (click)="refreshFilterOptions()">
        <fa-icon [icon]="icons.refresh"></fa-icon>
      </button>
      <button pButton type="button" [label]="ui('Clear', 'مسح')" class="p-button-text p-button-secondary icon-button"
        (click)="resetFilters()">
        <fa-icon [icon]="icons.filterClear"></fa-icon>
      </button>
      <button pButton type="button" [label]="ui('Search', 'بحث')" class="p-button-success icon-button"
        (click)="applyAdvancedFilters()">
        <fa-icon [icon]="icons.search"></fa-icon>
      </button>
    </div>
  </form>
</p-dialog>

<div class="availabilities-shell fade-in">
  <section class="page-hero">
    <div class="hero-content">
      <span class="eyebrow">{{ ui('Truck Marketplace', 'سوق الشاحنات') }}</span>
      <h1 class="hero-title">{{ 'AVAILABILITIES.FIND.TITLE' | translate }}</h1>
      <p class="hero-copy">{{ 'AVAILABILITIES.FIND.SUBTITLE' | translate }}</p>
      @if (activeSearchSummary(); as summary) {
      <div class="hero-search-summary" [class.is-empty]="summary.length === 0">
        @if (summary.length) {
        @for (item of summary; track item.label + item.value) {
        <span class="summary-chip" [title]="item.label + ': ' + item.value">
          <strong>{{ item.label }}</strong>
          <span>{{ item.value }}</span>
        </span>
        }
        } @else {
        <span class="summary-empty">{{ ui('No filters applied', 'لا توجد فلاتر مطبقة') }}</span>
        }
      </div>
      }
    </div>

    <div class="hero-side">
      <div class="hero-stats">
        <div class="stat-card">
          <fa-icon [icon]="icons.truck"></fa-icon>
          <span class="stat-value">{{ loadAvailabilitiesResult().totalElements || 0 }}</span>
          <span class="stat-label">{{ ui('Posted trucks', 'شاحنات منشورة') }}</span>
        </div>
        <div class="stat-card">
          <fa-icon [icon]="icons.list"></fa-icon>
          <span class="stat-value">{{ searchParams().size }}</span>
          <span class="stat-label">{{ ui('Per page', 'لكل صفحة') }}</span>
        </div>
      </div>

      <button pButton [label]="ui('Add Truck', 'إضافة شاحنة')" class="p-button-success action-button icon-button"
        (click)="router.navigate(['/fleet/post-availability'])">
        <fa-icon [icon]="icons.plus"></fa-icon>
      </button>
    </div>
  </section>

  <div class="grid board-grid">
    <div class="col-12 xl:col-9 panel-column">
      <section class="market-panel">
        <header class="panel-header">
          <div>
            <div class="panel-kicker"><fa-icon [icon]="icons.truck"></fa-icon> {{ ui('Truck Board', 'لوحة الشاحنات') }}</div>
            <h2>{{ activeView === 'List' ? ('AVAILABILITIES.FIND.LIST' | translate) : ('AVAILABILITIES.FIND.MAP' | translate) }}</h2>
            <p>{{ ui('Newest trucks first, filtered by lane, date, equipment, and fleet scope.', 'أحدث الشاحنات أولاً مع التصفية حسب المسار والتاريخ والمعدة ونطاق الأسطول.') }}</p>
          </div>

          <div class="header-meta">
            <p-tag [value]="loading() ? ui('Loading', 'جاري التحميل') : ui((loadAvailabilitiesResult().totalElements || 0) + ' trucks', (loadAvailabilitiesResult().totalElements || 0) + ' شاحنات')"
              [severity]="loading() ? 'info' : 'success'" [rounded]="true"></p-tag>
            <div class="view-toggle">
              <button pButton [label]="'AVAILABILITIES.FIND.LIST' | translate"
                [class]="(activeView === 'List' ? 'p-button-sm p-button-success' : 'p-button-sm p-button-text p-button-secondary') + ' icon-button'"
                (click)="setView('List')">
                <fa-icon [icon]="icons.list"></fa-icon>
              </button>
              <button pButton [label]="'AVAILABILITIES.FIND.MAP' | translate"
                [class]="(activeView === 'Map' ? 'p-button-sm p-button-success' : 'p-button-sm p-button-text p-button-secondary') + ' icon-button'"
                (click)="setView('Map')">
                <fa-icon [icon]="icons.map"></fa-icon>
              </button>
            </div>
          </div>
        </header>

        <div class="results-summary">
          <span>{{ ui('Page', 'صفحة') }} {{ searchParams().page + 1 }}</span>
          <span>{{ ui('Sorted: newest first', 'الترتيب: الأحدث أولاً') }}</span>
        </div>

        @if (activeView === 'List') {
        <div class="scrollable-list">
          @if (loading()) {
          <div class="state-block">
            <i class="pi pi-spin pi-spinner"></i>
            <span>{{ ui('Loading trucks...', 'جاري تحميل الشاحنات...') }}</span>
          </div>
          } @else if (loadError()) {
          <div class="state-block empty-state">
            <fa-icon [icon]="icons.warning"></fa-icon>
            <span>{{ ui('Unable to load trucks. Please try again.', 'تعذر تحميل الشاحنات. يرجى المحاولة مرة أخرى.') }}</span>
          </div>
          } @else {
          @for (avail of loadAvailabilitiesResult().content || []; track avail.id) {
          <article class="match-card availability-card" (click)="openAvailability(avail.id)">
            <div class="card-topline">
              <div class="carrier-head">
                <p-avatar [label]="carrierInitial(avail)" shape="circle" styleClass="carrier-avatar"></p-avatar>
                <div>
                  <div class="carrier-name">{{ carrierName(avail) }}</div>
                  <div class="carrier-subtitle">{{ avail.availabilityNumber || avail.referenceNumber || ui('Truck #' + avail.id, 'شاحنة #' + avail.id) }}</div>
                </div>
              </div>

              <div class="card-actions" (click)="$event.stopPropagation()">
                <button pButton [label]="ui('View Details', 'عرض التفاصيل')"
                  class="p-button-outlined p-button-secondary p-button-sm icon-button"
                  (click)="openAvailability(avail.id)">
                  <fa-icon [icon]="icons.list"></fa-icon>
                </button>
              </div>
            </div>

            <div class="signal-strip">
              @for (badge of signalBadges(avail); track badge.label) {
              <span class="info-chip demand-chip" [class.accent-chip]="badge.strong">
                <fa-icon [icon]="badge.icon"></fa-icon>{{ badge.label }}
              </span>
              }
            </div>

            <div class="route-block">
              <div class="route-marker">
                <span class="dot origin-dot"></span>
                <span class="line"></span>
                <span class="dot destination-dot"></span>
              </div>
              <div class="route-copy">
                <div>
                  <div class="route-title">{{ avail.corridorOriginLabel || avail.corridorOrigin }}</div>
                  <div class="route-meta">{{ formatDisplayDate(avail.availableFrom, true) }}</div>
                </div>
                <div>
                  <div class="route-title">{{ avail.corridorDestinationLabel || avail.corridorDestination }}</div>
                  <div class="route-meta">{{ formatDisplayDate(avail.availableTo, true) }}</div>
                </div>
              </div>
            </div>

            <div class="chips-row">
              <span class="info-chip"><fa-icon [icon]="icons.truck"></fa-icon>{{ avail.equipmentTypeLabel || avail.equipmentType || ui('Any equipment', 'أي معدة') }}</span>
              @if (avail.availabilityWindow) {
              <span class="info-chip"><fa-icon [icon]="icons.clock"></fa-icon>{{ avail.availabilityWindow }}</span>
              }
              @if (avail.availablePallets) {
              <span class="info-chip"><fa-icon [icon]="icons.table"></fa-icon>{{ formatPallets(avail.availablePallets) }}</span>
              }
              @if (avail.maxWeightLbs) {
              <span class="info-chip"><fa-icon [icon]="icons.weight"></fa-icon>{{ formatWeightLbs(avail.maxWeightLbs) }}</span>
              }
              @if (!avail.transportationAgencyId) {
              <span class="info-chip accent-chip"><fa-icon [icon]="icons.user"></fa-icon>{{ ui('Independent Driver', 'سائق مستقل') }}</span>
              }
            </div>

            @if (avail.trustSummary; as trust) {
            <div class="chips-row">
              <span class="info-chip">
                <fa-icon [icon]="icons.shield"></fa-icon>{{ trustBadgeLabel(trust) }}
              </span>
              @if (trust.company?.paymentConfidence) {
              <span class="info-chip">{{ ui('Payment', 'الدفع') }}: {{ labelize(trust.company?.paymentConfidence) }}</span>
              }
              @if (trust.company?.assuranceStatus) {
              <span class="info-chip">{{ labelize(trust.company?.assuranceStatus) }}</span>
              }
              @if (trust.company?.trustScore !== null && trust.company?.trustScore !== undefined) {
              <span class="info-chip accent-chip">{{ ui('Score', 'الدرجة') }} {{ trust.company?.trustScore }}/100</span>
              }
              @if (!trust.company && trust.customer?.mobileVerified) {
              <span class="info-chip">{{ ui('Mobile verified', 'الجوال موثق') }}</span>
              }
            </div>
            }
          </article>
          } @empty {
          <div class="state-block empty-state">
            <fa-icon [icon]="icons.truck"></fa-icon>
            <span>{{ ui('No trucks found matching your criteria.', 'لم يتم العثور على شاحنات تطابق معاييرك.') }}</span>
          </div>
          }
          }
        </div>

        <div class="pagination-panel">
          <p-paginator [rows]="searchParams().size" [totalRecords]="loadAvailabilitiesResult().totalElements || 0"
            [first]="searchParams().page * searchParams().size" [rowsPerPageOptions]="[10, 20, 50]"
            (onPageChange)="onPageChange($event)"></p-paginator>
        </div>
        } @else {
        <div class="map-board">
          <div class="map-surface">
            @if (loading()) {
            <div class="state-block">
              <i class="pi pi-spin pi-spinner"></i>
              <span>{{ ui('Loading trucks...', 'جاري تحميل الشاحنات...') }}</span>
            </div>
            } @else if (selectedMapAvailability(); as availability) {
            <app-google-map class="w-full h-full block" [origin]="availability.corridorOrigin"
              [destination]="availability.corridorDestination" [zoom]="6">
            </app-google-map>
            } @else {
            <div class="state-block empty-state">
              <fa-icon [icon]="icons.map"></fa-icon>
              <span>{{ ui('No mapped trucks found.', 'لا توجد شاحنات على الخريطة.') }}</span>
            </div>
            }
          </div>

          <aside class="map-route-panel">
            <div class="map-route-header">
              <span class="panel-kicker"><fa-icon [icon]="icons.route"></fa-icon> {{ ui('Routes', 'المسارات') }}</span>
              <strong>{{ ui('Truck Routes', 'مسارات الشاحنات') }}</strong>
            </div>
            <div class="availability-map-list">
              @for (availability of mapAvailabilities(); track availability.id) {
              <button type="button" class="route-option"
                [class.is-selected]="selectedMapAvailabilityId() === availability.id"
                (click)="selectMapAvailability(availability)">
                <span>{{ availability.availabilityNumber || availability.referenceNumber || ui('Truck #' + availability.id, 'شاحنة #' + availability.id) }}</span>
                <strong>{{ availability.corridorOriginLabel || availability.corridorOrigin }} &#8594; {{ availability.corridorDestinationLabel || availability.corridorDestination }}</strong>
                <small>{{ availability.equipmentTypeLabel || availability.equipmentType || ui('Any equipment', 'أي معدة') }} &bull; {{ formatDisplayDate(availability.availableFrom) }}</small>
              </button>
              } @empty {
              <div class="state-block empty-state compact">
                <fa-icon [icon]="icons.inbox"></fa-icon>
                <span>{{ ui('No routes available.', 'لا توجد مسارات متاحة.') }}</span>
              </div>
              }
            </div>
          </aside>
        </div>
        }
      </section>
    </div>

    <div class="col-12 xl:col-3 panel-column">
      <section class="action-card filters-panel">
        <header class="compact-header">
          <div>
            <span class="panel-kicker">{{ ui('Refine', 'تنقيح') }}</span>
            <h2>{{ 'AVAILABILITIES.FIND.FILTERS' | translate }}</h2>
          </div>
          <button pButton [label]="'AVAILABILITIES.FIND.RESET' | translate"
            class="p-button-text p-button-secondary p-button-sm icon-button" (click)="resetFilters()">
            <fa-icon [icon]="icons.filterClear"></fa-icon>
          </button>
        </header>

        <div class="company-toggle">
          <span>{{ ui('My Company', 'شركتي') }}</span>
          <p-toggleswitch [(ngModel)]="useTransportationAgencyFilter"
            (onChange)="toggleTransportationAgencyFilter($event)"></p-toggleswitch>
        </div>
        <button pButton type="button" [label]="ui('My Trucks', 'شاحناتي')"
          [class]="(useMyAvailabilitiesFilter ? 'p-button-success' : 'p-button-outlined p-button-secondary') + ' scope-filter-button icon-button'"
          (click)="toggleMyAvailabilitiesFilter()">
          <fa-icon [icon]="icons.user"></fa-icon>
        </button>
        <button pButton type="button" [label]="ui('Advanced Search', 'بحث متقدم')"
          class="p-button-outlined p-button-secondary scope-filter-button icon-button" (click)="openAdvancedSearch()">
          <fa-icon [icon]="icons.sliders"></fa-icon>
        </button>

        <form [formGroup]="filtersForm" class="filters-form">
          <div class="filter-field">
            <p-inputGroup>
              <p-inputGroupAddon><fa-icon [icon]="icons.marker"></fa-icon></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select [options]="originOptions()" formControlName="origin" appendTo="body" [filter]="true"
                  inputId="origin" class="w-full" [showClear]="true"
                  (onFilter)="onLocationOptionFilter('origin', $event)"></p-select>
                <label for="origin">{{ 'AVAILABILITIES.FIND.ORIGIN' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>

          <div class="filter-field">
            <p-inputGroup>
              <p-inputGroupAddon><fa-icon [icon]="icons.mapLocation"></fa-icon></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select [options]="destinationOptions()" formControlName="destination" appendTo="body" [filter]="true"
                  inputId="destination" class="w-full" [showClear]="true"
                  (onFilter)="onLocationOptionFilter('destination', $event)"></p-select>
                <label for="destination">{{ 'AVAILABILITIES.FIND.DESTINATION' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>

          <div class="filter-field">
            <p-inputGroup>
              <p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
              <p-iftaLabel>
                <p-datepicker id="date" formControlName="date" appendTo="body" styleClass="w-full"
                  [showIcon]="false"></p-datepicker>
                <label for="date">{{ 'AVAILABILITIES.FIND.DATE' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>

          <div class="filter-field">
            <p-inputGroup>
              <p-inputGroupAddon><fa-icon [icon]="icons.truck"></fa-icon></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select [options]="equipmentOptions()" formControlName="equipment" appendTo="body"
                  [filter]="true"
                  inputId="equipment" class="w-full" [showClear]="true"
                  (onFilter)="onLocationOptionFilter('equipment', $event)"></p-select>
                <label for="equipment">{{ 'AVAILABILITIES.FIND.EQUIPMENT' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>

          <div class="filter-field">
            <p-inputGroup>
              <p-inputGroupAddon><fa-icon [icon]="icons.table"></fa-icon></p-inputGroupAddon>
              <p-iftaLabel>
                <p-inputNumber inputId="minPallets" formControlName="minPallets" [min]="0"
                  [showButtons]="false"></p-inputNumber>
                <label for="minPallets">{{ ui('Min pallets', 'أقل عدد منصات') }}</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>

          <div class="filter-field">
            <p-inputGroup>
              <p-inputGroupAddon><fa-icon [icon]="icons.weight"></fa-icon></p-inputGroupAddon>
              <p-iftaLabel>
                <p-inputNumber inputId="maxWeight" formControlName="maxWeight" [min]="0"
                  [showButtons]="false"></p-inputNumber>
                <label for="maxWeight">{{ ui('Min weight capacity', 'أقل سعة وزن') }}</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>

          <div class="preference-card">
            <span class="selection-label">{{ 'AVAILABILITIES.FIND.PREFERENCES' | translate }}</span>
            <label class="checkbox-row">
              <p-checkbox formControlName="hazmatCertified" [binary]="true" inputId="hazmat"></p-checkbox>
              <span>{{ ui('Hazmat Certified', 'معتمد للمواد الخطرة') }}</span>
            </label>
            <label class="checkbox-row">
              <p-checkbox formControlName="teamDrivers" [binary]="true" inputId="team"></p-checkbox>
              <span>{{ ui('Team Drivers', 'سائقان') }}</span>
            </label>
          </div>

          <button pButton type="button" [label]="'AVAILABILITIES.FIND.APPLY' | translate"
            class="w-full p-button-success action-button icon-button" (click)="applyFilters()">
            <fa-icon [icon]="icons.search"></fa-icon>
          </button>
        </form>
      </section>
    </div>
  </div>
</div>
